// extracted by mini-css-extract-plugin
export default {"confirm-dialog-alert":"ConfirmationDialog_confirm-dialog-alert__DMcez","confirm-dialog-actions":"ConfirmationDialog_confirm-dialog-actions__9cmMm"};